module.exports = __webpack_public_path__ + "img/primary_11x2.34644692.svg";